module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.b27d5627.woff";